var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { parseAgendaState } from "../types/agenda";
export var useTitleWithIsbnFilters = function () {
    var history = useHistory();
    var location = useLocation();
    var initialFilters = {
        name: "",
        isbn: "",
        publisherId: "",
        days: "",
        statuses: [],
        provisional: false,
        extraCopies: false,
        extraCopyReason: "",
        agendaState: "",
    };
    var _a = useState(initialFilters), filters = _a[0], setFilters = _a[1];
    var _b = useState(initialFilters), appliedFilters = _b[0], setAppliedFilters = _b[1];
    var _c = useState(""), publisherQuery = _c[0], setPublisherQuery = _c[1];
    var updateUrlWithFilters = function (newFilters) {
        var params = new URLSearchParams();
        if (newFilters.name)
            params.set("name", newFilters.name);
        if (newFilters.isbn)
            params.set("isbn", newFilters.isbn);
        if (newFilters.publisherId)
            params.set("publisherId", newFilters.publisherId);
        if (newFilters.days)
            params.set("days", newFilters.days);
        newFilters.statuses.forEach(function (status) { return params.append("statuses", status); });
        if (newFilters.provisional)
            params.set("provisional", "true");
        if (newFilters.extraCopies)
            params.set("extraCopies", "true");
        if (newFilters.extraCopyReason)
            params.set("extraCopyReason", newFilters.extraCopyReason);
        if (newFilters.agendaState)
            params.set("agendaState", newFilters.agendaState);
        history.push({ search: params.toString() });
    };
    var handleFilterChange = function (field, value) {
        var _a;
        var newFilters = __assign(__assign({}, filters), (_a = {}, _a[field] = value, _a));
        if (field === "extraCopies" && value === false) {
            newFilters.extraCopyReason = "";
        }
        setFilters(newFilters);
    };
    var handleStatusChange = function (status) {
        var newStatuses = filters.statuses.includes(status)
            ? filters.statuses.filter(function (s) { return s !== status; })
            : __spreadArray(__spreadArray([], filters.statuses, true), [status], false);
        handleFilterChange("statuses", newStatuses);
    };
    var handlePublisherInput = function (inputValue) {
        if (inputValue !== publisherQuery) {
            setPublisherQuery(inputValue);
        }
    };
    var handleApplyFilters = function () {
        setAppliedFilters(filters);
        updateUrlWithFilters(filters);
    };
    var handleClearFilters = function () {
        var clearedFilters = initialFilters;
        setFilters(clearedFilters);
        setAppliedFilters(clearedFilters);
        setPublisherQuery("");
        history.push({ search: "" });
    };
    var isAnyFilterActive = function () {
        return (appliedFilters.name.length > 0 ||
            appliedFilters.isbn.length > 0 ||
            appliedFilters.publisherId.length > 0 ||
            appliedFilters.days.length > 0 ||
            appliedFilters.statuses.length > 0 ||
            appliedFilters.provisional ||
            appliedFilters.extraCopies ||
            appliedFilters.extraCopyReason.length > 0 ||
            appliedFilters.agendaState.length > 0);
    };
    var hasUnappliedChanges = function () {
        return JSON.stringify(filters) !== JSON.stringify(appliedFilters);
    };
    useEffect(function () {
        var queryParams = new URLSearchParams(location.search);
        var newFilters = {
            name: queryParams.get("name") || "",
            isbn: queryParams.get("isbn") || "",
            publisherId: queryParams.get("publisherId") || "",
            days: queryParams.get("days") || "",
            statuses: queryParams.getAll("statuses"),
            provisional: queryParams.get("provisional") === "true",
            extraCopies: queryParams.get("extraCopies") === "true",
            extraCopyReason: queryParams.get("extraCopyReason") || "",
            agendaState: parseAgendaState(queryParams.get("agendaState")),
        };
        if (JSON.stringify(newFilters) !== JSON.stringify(appliedFilters)) {
            setFilters(newFilters);
            setAppliedFilters(newFilters);
        }
    }, [location.search, appliedFilters]);
    return {
        filters: filters,
        appliedFilters: appliedFilters,
        publisherQuery: publisherQuery,
        handleFilterChange: handleFilterChange,
        handleStatusChange: handleStatusChange,
        handlePublisherInput: handlePublisherInput,
        handleApplyFilters: handleApplyFilters,
        handleClearFilters: handleClearFilters,
        isAnyFilterActive: isAnyFilterActive,
        hasUnappliedChanges: hasUnappliedChanges,
    };
};
